module.exports = __webpack_public_path__ + "img/18.779e48ec.png";